document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper !== "undefined") {
    initReviewsSlider();
  } else {
    loadSwiper(initReviewsSlider);
  }
  setupClaimButton();
});

function loadSwiper(callback) {
  if (!document.querySelector('link[href*="swiper"]')) {
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
    document.head.appendChild(link);
  }
  var script = document.createElement("script");
  script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
  script.onload = callback;
  document.head.appendChild(script);
}

function initReviewsSlider() {
  var el = document.querySelector(".reviewSwiper");
  if (!el) return;
  new Swiper(".reviewSwiper", {
    slidesPerView: "auto",
    spaceBetween: 15,
    centeredSlides: false,
    loop: true,
    speed: parseInt(el.dataset.speed || 5000),
    autoplay: { delay: 1, disableOnInteraction: false },
    allowTouchMove: true,
    grabCursor: true,
    freeMode: { enabled: false },
  });
}

function setupClaimButton() {
  var claimButton = document.querySelector(".claim-button");
  if (claimButton) {
  }
}

function scrollToTop(event) {
  event.preventDefault();
  window.scrollTo({ top: 0, behavior: "smooth" });
}
